import LOGO from "../images/adrianes.png";

export const Team__Adrianes = {
  name: "Adrianes",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#770004",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 27 + 33 + 40,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 29 + 19 + 36,
    },
  ],
};
